import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Container from '../common/container';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  
  const faqs = [
    {
      question: "What exactly is conversational commerce?",
      answer: "Conversational commerce enables businesses to sell products, provide customer service, and build relationships directly through messaging platforms like WhatsApp and Telegram. It turns everyday conversations into opportunities for business growth."
    },
    {
      question: "How does WymBee work?",
      answer: "Our platform connects to your WhatsApp Business API and provides a dashboard where you can create automated workflows, manage customer conversations, and analyze performance—all without writing a single line of code."
    },
    {
      question: "Do I need technical expertise to use WymBee?",
      answer: "No. Our platform is designed with a no-code interface, making it accessible for team members without technical expertise."
    },
    {
      question: "How long does implementation take?",
      answer: "Basic implementation can be completed within 1-3 days after Meta verification. Full customization might take 1-2 weeks depending on complexity."
    },
    {
      question: "Can WymBee integrate with our existing systems?",
      answer: "Yes, WymBee integrates with various business tools including CRMs, calendars, spreadsheets, payment systems, and social media platforms."
    },
    {
      question: "What happens if a customer needs human assistance?",
      answer: "Our platform includes intelligent escalation that routes complex inquiries to your team members when automation can't resolve an issue."
    },
    {
      question: "How secure is customer data on your platform?",
      answer: "We maintain industry-standard security protocols and compliance with data protection regulations. All conversations are encrypted, and we do not share customer data with third parties."
    },
    {
      question: "How much can we save by using WymBee?",
      answer: "Our clients typically reduce operational costs by 60%, while increasing response speed by 5x and enabling 24/7 service availability."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600">
            Everything you need to know about our platform and services.
          </p>
        </motion.div>
        
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.05 * index }}
              className="mb-4"
            >
              <button
                onClick={() => toggleFaq(index)}
                className={`w-full text-left p-6 rounded-lg flex justify-between items-center transition-colors duration-300 ${
                  openIndex === index ? 'bg-white shadow-sm' : 'bg-white/50 hover:bg-white/80'
                }`}
              >
                <span className="font-medium text-lg">{faq.question}</span>
                <span className={`transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="p-6 pt-2 text-gray-600">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}